<p-toast></p-toast>

<div class="p-3">
  <div class="page-title mb-4">
    <h3>Settings</h3>
  </div>

  <p-tabView>
    <p-tabPanel header="Edit Profile">
      <div class="settings-card mx-auto">
        <h5 class="settings-section-title">Profile Information</h5>
        <p class="settings-section-sub">Update your display name. Email and phone are managed by your property manager.</p>

        <form [formGroup]="profileForm" (ngSubmit)="saveProfile()" class="settings-form mt-4">

          <div class="field">
            <label for="firstName">First Name <span class="text-danger">*</span></label>
            <input id="firstName" type="text" pInputText formControlName="firstName"
              placeholder="First name" class="w-100" maxlength="50" />
            <small class="text-danger d-block"
              *ngIf="profileForm.get('firstName')?.touched && (profileForm.get('firstName')?.hasError('required') || profileForm.get('firstName')?.hasError('whitespace'))">
              First name is required.
            </small>
            <small class="text-danger d-block"
              *ngIf="profileForm.get('firstName')?.touched && profileForm.get('firstName')?.hasError('maxlength')">
              Maximum 50 characters.
            </small>
            <small class="text-danger d-block"
              *ngIf="profileForm.get('firstName')?.touched && profileForm.get('firstName')?.hasError('pattern')">
              Only letters, spaces, hyphens and apostrophes are allowed.
            </small>
          </div>

          <div class="field">
            <label for="lastName">Last Name</label>
            <input id="lastName" type="text" pInputText formControlName="lastName"
              placeholder="Last name" class="w-100" maxlength="50" />
            <small class="text-danger d-block"
              *ngIf="profileForm.get('lastName')?.touched && (profileForm.get('lastName')?.hasError('required') || profileForm.get('lastName')?.hasError('whitespace'))">
              Last name is required.
            </small>
            <small class="text-danger d-block"
              *ngIf="profileForm.get('lastName')?.touched && profileForm.get('lastName')?.hasError('maxlength')">
              Maximum 50 characters.
            </small>
            <small class="text-danger d-block"
              *ngIf="profileForm.get('lastName')?.touched && profileForm.get('lastName')?.hasError('pattern')">
              Only letters, spaces, hyphens and apostrophes are allowed.
            </small>
          </div>

          <div class="field">
            <label for="email">Email Address</label>
            <input id="email" type="email" pInputText formControlName="email"
              class="w-100 readonly-field" readonly />
            <small class="field-hint"><i class="pi pi-lock me-1"></i>Managed by property manager</small>
          </div>

          <div class="field">
            <label for="phone">Phone Number</label>
            <input id="phone" type="text" pInputText formControlName="phone"
              class="w-100 readonly-field" readonly />
            <small class="field-hint"><i class="pi pi-lock me-1"></i>Managed by property manager</small>
          </div>

          <p-button type="submit" label="Save Changes" icon="pi pi-check"
            class="primary-btn mt-2" [loading]="saving"
            [disabled]="profileForm.invalid">
          </p-button>

        </form>
      </div>
    </p-tabPanel>
    <p-tabPanel header="Change Password">
      <div class="settings-card mx-auto">
        <h5 class="settings-section-title">Change Password</h5>
        <p class="settings-section-sub">Choose a strong password with at least 8 characters.</p>

        <form [formGroup]="passwordForm" (ngSubmit)="savePassword()" class="settings-form mt-4">

          <div class="field">
            <label for="newPassword">New Password</label>
            <p-password id="newPassword" formControlName="newPassword"
              placeholder="Enter new password"
              [toggleMask]="true" [feedback]="true"
              styleClass="w-100" inputStyleClass="w-100">
            </p-password>
            <ng-container *ngIf="passwordForm.get('newPassword')?.touched">
              <small class="text-danger d-block" *ngIf="passwordForm.get('newPassword')?.hasError('required')">Password is required.</small>
              <small class="text-danger d-block" *ngIf="passwordForm.get('newPassword')?.hasError('minlength')">At least 6 characters required.</small>
              <small class="text-danger d-block" *ngIf="passwordForm.get('newPassword')?.hasError('uppercase')">Must include at least 1 uppercase letter.</small>
              <small class="text-danger d-block" *ngIf="passwordForm.get('newPassword')?.hasError('lowercase')">Must include at least 1 lowercase letter.</small>
              <small class="text-danger d-block" *ngIf="passwordForm.get('newPassword')?.hasError('special')">Must include at least 1 special character.</small>
            </ng-container>
          </div>

          <div class="field">
            <label for="confirmPassword">Confirm Password</label>
            <p-password id="confirmPassword" formControlName="confirmPassword"
              placeholder="Re-enter new password"
              [toggleMask]="true" [feedback]="false"
              styleClass="w-100" inputStyleClass="w-100">
            </p-password>
            <small class="text-danger"
              *ngIf="passwordForm.get('confirmPassword')?.touched && passwordForm.hasError('mismatch')">
              Passwords do not match.
            </small>
          </div>

          <p-button type="submit" label="Update Password" icon="pi pi-lock"
            class="primary-btn mt-2" [loading]="savingPassword"
            [disabled]="passwordForm.invalid">
          </p-button>

        </form>
      </div>
    </p-tabPanel>

    <p-tabPanel header="Email Notification">
      <div class="settings-card notif-card mx-auto">

        <h5 class="settings-section-title">Email Notifications</h5>
        <p class="settings-section-sub">Control which emails you receive from the system.</p>

        <div class="notif-row notif-row--global mt-4">
          <div class="notif-info">
            <span class="notif-label">All Email Notifications</span>
            <span class="notif-desc">Globally enable or disable all email communications.</span>
          </div>
          <p-inputSwitch [(ngModel)]="allEnabled"></p-inputSwitch>
        </div>

        <p-divider></p-divider>
        <div class="notif-row"
          *ngFor="let item of notificationItems"
          [class.notif-row--disabled]="!allEnabled">
          <div class="notif-info">
            <span class="notif-label">{{ item.label }}</span>
            <span class="notif-desc">{{ item.desc }}</span>
          </div>
          <p-inputSwitch [(ngModel)]="notifications[item.key]"
            [disabled]="!allEnabled">
          </p-inputSwitch>
        </div>

        <div class="mt-4">
          <p-button type="button" label="Save Preferences" icon="pi pi-check"
            class="primary-btn" [loading]="savingNotifications"
            [disabled]="savingNotifications" (click)="saveNotifications()">
          </p-button>
        </div>

      </div>
    </p-tabPanel>

  </p-tabView>
</div>
